import React from "react";
import powerbiLogo from "../logo/powerbiLogo.jpg";

export type DashboardItem = {
  id: string;
  name: string;
  workspaceId: string;
};

type DashboardCardProps = {
  dashboard: DashboardItem;
  onOpen: (d: DashboardItem) => void;
};

const DashboardCard: React.FC<DashboardCardProps> = React.memo(
  ({ dashboard, onOpen }) => {
    const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onOpen(dashboard);
      }
    };

    return (
      <div
        className="myapps-tile"
        role="button"
        tabIndex={0}
        onClick={() => onOpen(dashboard)}
        onKeyDown={onKeyDown}
        aria-label={`Open dashboard ${dashboard.name}`}
        title={dashboard.name}
      >
        <div className="myapps-tile-top">
          <div className="myapps-icon">
            <img src={powerbiLogo} alt="Power BI" className="powerbi-icon" />
          </div>
        </div>

        <div className="myapps-title" title={dashboard.name}>
          {dashboard.name}
        </div>

        <div className="myapps-subtitle">Click to view dashboard</div>
      </div>
    );
  },
);

export default DashboardCard;
